<script>
import Modal from '@maison/components/common/Modal';
import GenericForm from '@maison/components/form/GenericForm';

export default {
  components: {
    Modal,
    GenericForm,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    privacyLink: {
      type: String,
      required: true,
    },
    groups: {
      type: Object,
      required: true,
    },
    modalId: {
      type: String,
      default: 'cpra-modal',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    terms: {
      type: String,
      default: '',
    },
    textClasses: {
      type: String,
      default: '',
    },
    btnActionClasses: {
      type: String,
      default: 'btn',
    },
    btnTextActionClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    getPrivacyLink() {
      return `<a href="${this.privacyLink}" target="_blank">${this.$t('CPRA.modal.privacy.button')}</a>`;
    },
  },

  methods: {
    handleCookieClick() {
      if (window.tC && window.tC.privacyCenter) {
        window.tC.privacyCenter.showPrivacyCenter();
      }
    },
  },
};
</script>

<template>
  <div>
    <generic-form
      terms-translate-key="CPRA.form.agree"
      :form="form"
      :groups="groups"
      :countries="countries"
      :redirect-url="redirectUrl"
      :terms="terms"
      :is-contained="false"
    />
    <modal :id="modalId" :title="$t('cpra.form.title')">
      <template #content>
        <div :class="textClasses">
          <p
            v-html="
              $t('CPRA.modal.text', {
                link: getPrivacyLink,
                ctaText: $t('CPRA.modal.submit'),
              })
            "
          ></p>
        </div>
      </template>

      <template #footer>
        <button type="button" :class="btnActionClasses" @click="handleCookieClick">
          <span :class="btnTextActionClasses">
            {{ $t('CPRA.modal.submit') }}
          </span>
        </button>
      </template>
    </modal>
  </div>
</template>
